module.exports = __webpack_public_path__ + "img/seminar (14).f56fa36b.jpg";